import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/1/s/layouts/default.vue").then(m => m.default || m))
}